import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService, TransferenciaPrevista, Page } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TransferenciaPrevistaService extends BaseResourceService<TransferenciaPrevista> {

  constructor(
    protected injector: Injector
  ) {
    super(`transferencias-prevista`, injector);
  }

  public obter(filtros?: {}): Observable<TransferenciaPrevista> {
    let parametros = '';
    if (filtros) {
      // tslint:disable-next-line: forin
      for (const key in filtros) {
        if (parametros === '') {
          parametros += '?';
        } else {
          parametros += '&';
        }
        parametros += key + '=' + filtros[key];
      }
    }
    return this.http.get<Page>(`${this.login.cidade.id}/${this.api}/obter${parametros}`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public totalPrevistoRecebidoMes(exercicio: number, orgaoId: number): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${this.login.cidade.id}/${this.api}/total-previsto-recebido-mes/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalPrevistoConcedidoMes(exercicio: number, orgaoId: number): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${this.login.cidade.id}/${this.api}/total-previsto-concedido-mes/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalDuodecimoPorAno(orgaoId: number, anos: number[]): Observable<Array<any>> {
    const anosStr = anos.join(',');
    return this.http.get<Array<any>>(
      `${this.login.cidade.id}/${this.api}/total-duodecimo-por-ano/${orgaoId}/${anosStr}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalDevolucaoPorAno(orgaoId: number, anos: number[]): Observable<Array<any>> {
    const anosStr = anos.join(',');
    return this.http.get<Array<any>>(
      `${this.login.cidade.id}/${this.api}/total-devolucao-por-ano/${orgaoId}/${anosStr}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalDuodecimoMensalAnoAtual(exercicio: number, orgaoId: number): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${this.login.cidade.id}/${this.api}/total-duodecimo-mensal-ano-atual/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
